<template>
  <div id="app" class="min-h-screen bg-gray-50 flex flex-col">
    <AppHeader />
    <main class="flex-1">
      <router-view />
    </main>
    <footer class="border-t border-gray-200 bg-white">
      <div class="container py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-gray-500">
        <span>&copy; {{ year }} Pricing Calculator</span>
        <router-link to="/pricing-info" class="font-semibold text-primary-600 hover:text-primary-700">
          Transparent Decoration Pricing
        </router-link>
      </div>
    </footer>
  </div>
</template>

<script setup>
import AppHeader from './components/layout/AppHeader.vue'

const year = new Date().getFullYear()
</script>
